import { render } from "./index.vue?vue&type=template&id=688a5f4d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=688a5f4d&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=688a5f4d&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688a5f4d"]])

export default __exports__